import CloseIcon from "@mui/icons-material/Close";
import CommentIcon from "@mui/icons-material/Comment";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AuthService from "../../AuthService";
import utils from "../../utils";
import BarraTitulo from "../Generico/BarraTitulo";
import Template from "../Generico/Template";
import Infos from "./components/Infos";

const Avaliacao = () => {
  const [avaliacoes, setAvaliacoes] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // <-- Novo estado
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(
    window.screen.width <= 560 ? 500 : 10
  );
  const [open, setOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState({});

  useEffect(() => {
    getAvaliacoes();
  }, []);

  const getAvaliacoes = () => {
    setIsLoading(true);
    const service = new AuthService();
    service
      .get("/avaliacaoEmpresa/list")
      .then((resp) => {
        setAvaliacoes(resp);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleOpenObservacao = (avaliacao) => {
    const content = {
      title: avaliacao.pessoa
        ? avaliacao.pessoa.nome
        : avaliacao.pedido.nomeCliente,
      observacao: avaliacao.observacao,
    };

    setDialogContent(content);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDialogContent({});
  };

  const handleChangePage = (__, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const renderSkeletonRows = (count = rowsPerPage) =>
    [...Array(count)].map((_, index) => (
      <TableRow sx={{ width: "100vw" }} key={index}>
        <TableCell sx={{ width: "50%" }}>
          <Skeleton width="80%" />
        </TableCell>
        <TableCell sx={{ width: "20%" }}>
          <Skeleton width="70%" />
        </TableCell>
        <TableCell sx={{ width: "20%" }}>
          <Skeleton width="70%" />
        </TableCell>
        <TableCell sx={{ width: "10%" }} align="right">
          <Skeleton width="100%" />
        </TableCell>
      </TableRow>
    ));

  return (
    <>
      <Template documentTitle="Avaliações da empresa">
        <Box>
          <BarraTitulo
            title="Avaliações da empresa"
            subTitle="Veja as avaliações dos seus clientes sobre a sua empresa"
          />
          <Paper sx={{ padding: "1rem" }}>
            <Infos />
            <Divider />
            <TableContainer>
              <Table size="small">
                <TableBody>
                  {isLoading
                    ? renderSkeletonRows()
                    : avaliacoes
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((avaliacao) => (
                          <TableRow key={avaliacao.id}>
                            <TableCell align="left">
                              <Typography variant="h6">
                                {avaliacao.pessoa
                                  ? avaliacao.pessoa.nome
                                  : avaliacao.pedido.nomeCliente}
                              </Typography>
                            </TableCell>

                            <TableCell>
                              <Box display="flex" alignItems="center">
                                <Typography
                                  style={{
                                    fontSize: "115%",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                  }}
                                >
                                  Nota:
                                </Typography>
                                <Typography>
                                  {avaliacao.nota.toFixed(2)}
                                </Typography>
                              </Box>
                            </TableCell>

                            <TableCell>
                              {utils.formatarDataHora(
                                avaliacao.createdAt,
                                avaliacao.empresa.timezone
                              )}
                            </TableCell>

                            <TableCell align="right">
                              <Button
                                onClick={() => handleOpenObservacao(avaliacao)}
                                disabled={!avaliacao.observacao}
                              >
                                <CommentIcon style={{ marginRight: "10px" }} />
                                Comentários
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                labelRowsPerPage="Linhas por página"
                component="div"
                count={avaliacoes.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleRowsPerPage}
              />
            </TableContainer>
          </Paper>
        </Box>
      </Template>

      <Dialog maxWidth="md" fullWidth open={open} onClose={handleClose}>
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {dialogContent.title}
          <IconButton aria-label="close" onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ padding: "20px" }}>
          <Paper
            style={{
              backgroundColor: "#E2E6E6",
              borderRadius: "5px solid Gray",
              width: "100%",
            }}
          >
            <Typography style={{ padding: "15px" }}>
              {dialogContent.observacao}
            </Typography>
          </Paper>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Avaliacao;
